import {
  connectWixPaymentsAccount as publicConnectWixPaymentsAccount,
  connectWixPaymentsAccountBase44 as publicConnectWixPaymentsAccountBase44,
  setupBase44Site as publicSetupBase44Site,
} from './payments-mcp-v1-wix-payments-account-wix-payments-account.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const connectWixPaymentsAccount: MaybeContext<
  BuildRESTFunction<typeof publicConnectWixPaymentsAccount> &
    typeof publicConnectWixPaymentsAccount
> = /*#__PURE__*/ createRESTModule(publicConnectWixPaymentsAccount);
export const connectWixPaymentsAccountBase44: MaybeContext<
  BuildRESTFunction<typeof publicConnectWixPaymentsAccountBase44> &
    typeof publicConnectWixPaymentsAccountBase44
> = /*#__PURE__*/ createRESTModule(publicConnectWixPaymentsAccountBase44);
export const setupBase44Site: MaybeContext<
  BuildRESTFunction<typeof publicSetupBase44Site> & typeof publicSetupBase44Site
> = /*#__PURE__*/ createRESTModule(publicSetupBase44Site);

export {
  WixPaymentsAccount,
  TermsOfServiceAcceptance,
  ConnectWixPaymentsAccountRequest,
  ConnectWixPaymentsAccountResponse,
  ConnectWixPaymentsAccountBase44Request,
  Base44AppData,
  ConnectWixPaymentsAccountBase44Response,
  Base44Metadata,
  SetupBase44SiteRequest,
  SetupBase44SiteResponse,
  ConnectWixPaymentsAccountBase44Options,
  SetupBase44SiteOptions,
} from './payments-mcp-v1-wix-payments-account-wix-payments-account.universal.js';
export { ConnectWixPaymentsAccountBase44ApplicationErrors } from './payments-mcp-v1-wix-payments-account-wix-payments-account.universal.js';
